import React, { useState, useEffect } from "react";
import { Form, Card, Button, Modal } from "react-bootstrap";
import { useGlobalState } from "../../../../services/hostelConst";
 
import {
  callToast,
  showErrorMessages,
} from "../../../../services/utilityFunctions";
import { updateLibraryCategory, addLibraryCategory } from "../libraryServices/libraryManagement";

const AddLibraryCategoryForm = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();
  const masterData = modalState.data;
  const libraryId = modalState.libraryId || (masterData && masterData._LIBRARY);
  console.log("Library category modal state data:", masterData);
  console.log("Library category modal state libraryId:", libraryId);
  const [isLoading, setIsLoading] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    libraryId: libraryId || "",
    id: null,
  });
  const [errors, setErrors] = useState({});
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    if (masterData) {
      console.log("Loading category data for editing:", masterData);
      setFormData({
        name: masterData.NAME || masterData.name || "",
        description: masterData.DESCRIPTION || masterData.description || "",
        libraryId: masterData._LIBRARY || masterData.libraryId || libraryId || "",
        id: masterData._ID || masterData.id || null,
      });
    }
  }, [masterData, libraryId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Category Name is required";
    if (!formData.description?.trim()) newErrors.description = "Description is required";
    if (!formData.libraryId) newErrors.libraryId = "Library ID is required";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    handleConfirmedSubmit();
  };

  const handleConfirmedSubmit = async () => {
    setIsLoading(true);

    try {
      const response = formData.id
        ? await updateLibraryCategory({
            ...formData,
            id: formData.id,
          })
        : await addLibraryCategory(formData);

      if (response.status === "success") {
        const myButton = document.getElementById("myToastButton");
        callToast(
          "success",
          "Success",
          `Category ${formData.id ? "updated" : "added"} successfully!`,
          myButton
        );

        if (typeof refresh === "function") {
          await refresh({ columnRefresh: false, isLoading: false });
        }

        setTimeout(() => {
          closeModal();
        }, 2000);
      } else if (response.status === "fail") {
        showErrorMessages({ data: response, navigate });
        const myButton = document.getElementById("myToastButton");
        callToast(
          "error",
          "Error",
          response.message ||
            `Failed to ${formData.id ? "update" : "add"} category`,
          myButton
        );
      }
    } catch (error) {
      showErrorMessages({
        data: {
          message: `Failed to ${formData.id ? "update" : "add"} category`,
          errors: error.message,
        },
        navigate,
      });
      const myButton = document.getElementById("myToastButton");
      callToast("error", "Error", "An unexpected error occurred", myButton);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Card.Body className="px-4 py-4">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Category Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter category name"
              isInvalid={!!errors.name}
              className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.name}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-bold">Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter category description"
              rows={3}
              isInvalid={!!errors.description}
              className="shadow-sm"
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" onClick={closeModal} className="px-3">
              Cancel
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isLoading}
              className="px-4"
            >
              {isLoading
                ? formData.id
                  ? "Updating..."
                  : "Adding..."
                : formData.id
                ? "Update Category"
                : "Add Category"}
            </Button>
          </div>
        </Form>
      </Card.Body>
      
      <Modal
        show={showResponseModal}
        onHide={() => setShowResponseModal(false)}
        centered
        className={`response-modal ${modalConfig.type}`}
      >
        <Modal.Body className="text-center py-4">
          <div className={`response-icon ${modalConfig.type}`}>
            {modalConfig.type === "success" ? "✓" : "✕"}
          </div>
          <h5 className="mt-3">{modalConfig.title}</h5>
          <p className="mb-0">{modalConfig.message}</p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddLibraryCategoryForm;